import { render } from "./review.vue?vue&type=template&id=b2b684f0"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"
script.render = render

export default script